import { Box, Button, Grid, MenuItem, Stack } from "@mui/material"

import { Bound } from "lib/@components/binding/Bound"
import { BoundSwitch, BoundTextField } from "lib/@components/binding/bound-components"
import { clone } from "lib/clone"
import { useState } from "react"
import { setScheduledTask } from "routes/sfg20-admin/plugins/system-tab/scheduled-tasks-tab/controller/setScheduledTask"

import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { DATE_FORMATS } from "lib/@constants/date-format"
import { TaskRunningMan } from "./TaskRunningMan"

export function ScheduledTaskItem({ task }) {
    const [updated, setUpdated] = useState(false)
    const { target } = useBoundContext()

    const hasPullFromEnv = target.pullFromEnvOption === true

    const [original] = useState(clone(task))
    let lastRun = "?"
    lastRun = new Date(target.lastRun).format(DATE_FORMATS.dateAndTime)

    return (
        <Bound onChange={isUpdated}>
            <Grid container spacing={2} mt={2} mb={2} data-cy="scheduled-task-item">
                <Grid item xs={10} sx={{ alignContent: "end" }}>
                    <Grid container spacing={2} mb={0.5} sx={{ display: "flex", width: "100%" }}>
                        <Stack direction={"row"} px={2} width={"100%"}>
                            <Grid item flexGrow={1}>
                                <Box flexGrow={1} display="flex" width={"100%"}>
                                    {target.emittedEvent}
                                    {task.isRunning && <TaskRunningMan />}
                                </Box>
                            </Grid>
                        </Stack>
                    </Grid>
                </Grid>
                <Grid item xs={2} sx={{ textAlign: "right", alignContent: "end" }}>
                    Enabled:
                    <BoundSwitch label="Enabled" field="enabled" />
                </Grid>
                <Grid item xs={3}>
                    <BoundTextField label="Execute every" field="interval" />
                </Grid>
                <Grid item xs={hasPullFromEnv ? 2 : 3}>
                    <BoundTextField select sx={{ height: "100%" }} variant="outlined" field="unit">
                        <MenuItem value="second">Seconds</MenuItem>
                        <MenuItem value="minute">Minutes</MenuItem>
                        <MenuItem value="hour">Hours</MenuItem>
                    </BoundTextField>
                </Grid>
                <Grid item xs={hasPullFromEnv ? 2 : 3}>
                    <BoundTextField
                        select
                        sx={{ height: "100%" }}
                        variant="outlined"
                        field="runBetweenStart"
                        label="Between"
                    >
                        <MenuItem value="0000">00:00</MenuItem>
                        <MenuItem value="0100">01:00</MenuItem>
                        <MenuItem value="0200">02:00</MenuItem>
                        <MenuItem value="0300">03:00</MenuItem>
                        <MenuItem value="0400">04:00</MenuItem>
                        <MenuItem value="0500">05:00</MenuItem>
                        <MenuItem value="0600">06:00</MenuItem>
                        <MenuItem value="0700">07:00</MenuItem>
                        <MenuItem value="0800">08:00</MenuItem>
                        <MenuItem value="0900">09:00</MenuItem>
                        <MenuItem value="1000">10:00</MenuItem>
                        <MenuItem value="1100">11:00</MenuItem>
                        <MenuItem value="1200">12:00</MenuItem>
                        <MenuItem value="1300">13:00</MenuItem>
                        <MenuItem value="1400">14:00</MenuItem>
                        <MenuItem value="1500">15:00</MenuItem>
                        <MenuItem value="1600">16:00</MenuItem>
                        <MenuItem value="1700">17:00</MenuItem>
                        <MenuItem value="1800">18:00</MenuItem>
                        <MenuItem value="1900">19:00</MenuItem>
                        <MenuItem value="2000">20:00</MenuItem>
                        <MenuItem value="2100">21:00</MenuItem>
                        <MenuItem value="2200">22:00</MenuItem>
                        <MenuItem value="2300">23:00</MenuItem>
                        <MenuItem value="2359">23:59</MenuItem>
                    </BoundTextField>
                </Grid>
                <Grid item xs={hasPullFromEnv ? 2 : 3}>
                    <BoundTextField select sx={{ height: "100%" }} variant="outlined" field="runBetweenEnd" label="and">
                        <MenuItem value="0000">00:00</MenuItem>
                        <MenuItem value="0100">01:00</MenuItem>
                        <MenuItem value="0200">02:00</MenuItem>
                        <MenuItem value="0300">03:00</MenuItem>
                        <MenuItem value="0400">04:00</MenuItem>
                        <MenuItem value="0500">05:00</MenuItem>
                        <MenuItem value="0600">06:00</MenuItem>
                        <MenuItem value="0700">07:00</MenuItem>
                        <MenuItem value="0800">08:00</MenuItem>
                        <MenuItem value="0900">09:00</MenuItem>
                        <MenuItem value="1000">10:00</MenuItem>
                        <MenuItem value="1100">11:00</MenuItem>
                        <MenuItem value="1200">12:00</MenuItem>
                        <MenuItem value="1300">13:00</MenuItem>
                        <MenuItem value="1400">14:00</MenuItem>
                        <MenuItem value="1500">15:00</MenuItem>
                        <MenuItem value="1600">16:00</MenuItem>
                        <MenuItem value="1700">17:00</MenuItem>
                        <MenuItem value="1800">18:00</MenuItem>
                        <MenuItem value="1900">19:00</MenuItem>
                        <MenuItem value="2000">20:00</MenuItem>
                        <MenuItem value="2100">21:00</MenuItem>
                        <MenuItem value="2200">22:00</MenuItem>
                        <MenuItem value="2300">23:00</MenuItem>
                        <MenuItem value="2359">23:59</MenuItem>
                    </BoundTextField>
                </Grid>

                {hasPullFromEnv && (
                    <Grid item xs={3}>
                        <BoundTextField
                            select
                            sx={{ height: "100%" }}
                            variant="outlined"
                            field="pullFromEnv"
                            label="Environment to pull from"
                        >
                            <MenuItem value="">None</MenuItem>
                            <MenuItem value="https://api.dev.facilities-iq.com">Dev</MenuItem>
                            <MenuItem value="https://api.test.facilities-iq.com">Test</MenuItem>
                            <MenuItem value="https://api.demo.facilities-iq.com">Demo</MenuItem>
                            <MenuItem value="https://api.training.facilities-iq.com">Training</MenuItem>
                            <MenuItem value="https://api.uat.facilities-iq.com">UAT</MenuItem>
                            <MenuItem value="https://api.facilities-iq.com">Live</MenuItem>
                        </BoundTextField>
                    </Grid>
                )}
                <Grid item xs={6}>
                    Last Run: {lastRun}
                    {/* {dayjs(target.lastRun).format("DD-MMM, HH:mm")} */}
                    {/* DayJs? use new constants here? */}
                </Grid>
                <Grid item xs={3}>
                    Run Now requested:
                    {JSON.stringify(!!task.runNow)}
                </Grid>
                <Grid item xs={3}>
                    Is Errored:
                    {JSON.stringify(!!task.isErrored)}
                    {!!task.error && (
                        <>
                            Error Message:
                            {JSON.stringify(task.error)}
                        </>
                    )}
                </Grid>
                <Grid item container xs={12} justifyContent="flex-end">
                    {!!updated && (
                        <Button variant="contained" onClick={writeScheduledTask}>
                            Save Changes
                        </Button>
                    )}
                    {task.isRunning && (
                        <Button variant="contained" onClick={resetRunning}>
                            Reset Running State
                        </Button>
                    )}
                    {!updated && !task.isRunning && (
                        <Button variant="contained" onClick={runNow}>
                            Run Now
                        </Button>
                    )}
                </Grid>
            </Grid>
            <hr />
        </Bound>
    )

    // function convertDateTimeToTime(datetime) {
    //     try {
    //         return dayjs(datetime).format("HH:mm")
    //     } catch (e) {
    //         return "00:00"
    //     }
    // }
    //
    // function convertTimeToDateTime(time) {
    //     try {
    //         return dayjs(`2023-01-01T${time || "00:00"}`)
    //     } catch (e) {
    //         return dayjs(`2023-01-01T00:00`)
    //     }
    // }

    async function resetRunning() {
        task.isRunning = false
        task.runNow = false
        console.log({ task })
        await writeScheduledTask()
    }

    async function runNow() {
        task.runNow = true
        await writeScheduledTask()
    }

    async function writeScheduledTask() {
        setUpdated(false)
        await setScheduledTask(task)
    }

    function isUpdated() {
        setUpdated(!Object.isEqual(original, task))
    }
}
